
// ページトップへ
var syncerTimeout = null ;

$( function()
{
	$( window ).scroll( function()
	{
		if( syncerTimeout == null )
		{
			syncerTimeout = setTimeout( function(){

				var element = $( '#tr_page-top' ) ;

				var visible = element.is( ':visible' ) ;

				var now = $( window ).scrollTop() ;

                var under = $( 'body' ).height() - ( now + $(window).height() ) ;
                
                if (window.matchMedia( '(min-width: 767px)' ).matches) 
                {

                    //PCでボタンが表示される位置を調整
                    if( now > 100 && 430 < under )
                    {
                        if( !visible )
                        {
                            element.fadeIn( '10' ) ;
                        }
                    }
                
                    else if( visible )
                    {
                        element.fadeOut( '10' ) ;
                    }
                
                    } else {
                        //スマホでボタンが表示される位置を調整
                        if( now > 100 && 570 < under )
                        {
                            if( !visible )
                            {
                                element.fadeIn( '10' ) ;
                            }
                        }
                
                        else if( visible )
                        {
                            element.fadeOut( '10' ) ;
                        }
                    };

				syncerTimeout = null ;
			} , 100 ) ;
		}
	} ) ;

	$( '#tr_move-page-top' ).click(
		function()
		{
			$( 'html,body' ).animate( {scrollTop:1} , 'slow' ) ;
		}
	) ;
} ) ;